import VerifyEmail from "./verifyEmail"

export default VerifyEmail;
